define('controller/step/BookingRescheduleStepManager',['require','controller/step/BookingStepManager','view/controller/booking/BookingRescheduleUrlBuilder','controller/step/datetime/SlotsDateTimeStep','controller/step/datetime/SlotsWeeklyDateTimeStep','controller/step/datetime/FlexibleDateTimeStep','controller/step/datetime/FlexibleWeeklyDateTimeStep'],function (require) {

	var Parent = require('controller/step/BookingStepManager');
    var BookingRescheduleUrlBuilder = require('view/controller/booking/BookingRescheduleUrlBuilder');
    
    var SlotsDateTimeStep = require('controller/step/datetime/SlotsDateTimeStep');
	var SlotsWeeklyDateTimeStep = require('controller/step/datetime/SlotsWeeklyDateTimeStep');
	var FlexibleDateTimeStep = require('controller/step/datetime/FlexibleDateTimeStep');
	var FlexibleWeeklyDateTimeStep = require('controller/step/datetime/FlexibleWeeklyDateTimeStep');

    return Parent.extend({
        
        initialize: function() {
            Parent.prototype.initialize.apply(this);
            
            this._stepObjects = {};
        },
        
        _getTimelineStepInstance: function (stepParams) {
            switch (Config.getInstance().getTimelineType()) {
                case Config.TIMELINE_CLASSES: // modern provider
                case Config.TIMELINE_CLASSES_PLUGIN: // daily classes
                case Config.TIMELINE_SLOTS:
                    return new SlotsDateTimeStep(stepParams);
                    
                case Config.TIMELINE_GRID_WEEKLY: // weekly classes
                case Config.TIMELINE_SLOTS_WEEKLY:
                    return new SlotsWeeklyDateTimeStep(stepParams);
                    
                case Config.TIMELINE_FLEXIBLE_PROVIDER:
                case Config.TIMELINE_FLEXIBLE:
                    return new FlexibleDateTimeStep(stepParams);
                    
                case Config.TIMELINE_FLEXIBLE_WEEKLY:
                    return new FlexibleWeeklyDateTimeStep(stepParams);
                
                default:
                    // default time step.
                    return new SlotsWeeklyDateTimeStep(stepParams);
            }
        },
        
        _reformatSteps: function () {
            // do nothing - we need data from all steps
        },
        
        getRouteName: function () {
            return 'reschedule';
        },
        
        getUrlBuilder: function () {
            return BookingRescheduleUrlBuilder.getInstance();
        }
	    
	});
	
});
